module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-120x120-fe9380cab558da5c8bd0c39f71bd9481.png";